<template>
  <div class="VCandyCaneLoader"></div>
</template>

<script>
export default {
  name: "VCandyCaneLoader"
};
</script>

<style lang="scss" scoped>
.VCandyCaneLoader {
  height: 14px;
  width: auto;
  border-radius: 6px;
  background-color: darken($color-plaster, 6);
  border: 1px solid darken($color-plaster, 6);
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.8) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 75%,
    transparent 75%,
    transparent
  );
  background-size: 24px 24px;
  animation: loading-stripes 1s linear infinite;
  @keyframes loading-stripes {
    from {
      background-position: 0 0;
    }
    to {
      background-position: 50px 0;
    }
  }
}
</style>
